"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var FooterList_1 = __importDefault(require("./FooterList"));
var Languages_1 = __importDefault(require("../Languages"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var FooterMenu = function (_a) {
    var restrictedLicenseCountries = _a.restrictedLicenseCountries, footerMenu = _a.footerMenu, languages = _a.languages, _b = _a.LicenseWidget, LicenseWidget = _b === void 0 ? null : _b;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var footerMenuWithLangs = (0, react_1.useMemo)(function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.menuWrapper },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.menuContainer },
                    react_1.default.createElement(FooterList_1.default, { title: t('info'), list: footerMenu.info }),
                    react_1.default.createElement(FooterList_1.default, { title: t('legal'), list: footerMenu.legal }),
                    react_1.default.createElement(FooterList_1.default, { title: t('games'), list: footerMenu.games }))),
            react_1.default.createElement(Languages_1.default, { languages: languages })));
    }, [t, footerMenu, languages]);
    if (Object.keys(breakpoints).length === 0)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        LicenseWidget ? react_1.default.createElement(LicenseWidget, null) : null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.licenseContainer }),
        breakpoints.tablet && (react_1.default.createElement("div", { className: styles_module_scss_1.default.tabWrapper }, footerMenuWithLangs)),
        !breakpoints.tablet && footerMenuWithLangs));
};
exports.default = FooterMenu;
